SharedUtilsHelper = require('../../../shared/frontend/helpers/utils')
Hogan = require('../../../../node_modules/hogan.js/web/builds/2.0.0/hogan-2.0.0')
Backbone = require 'backbone'
Backbone.$ = $
FaqDetailedarticleTemplate = require('../../detailedarticle.html.mustache')
FaqSummarizedarticleTemplate = require('../../summarizedarticle.html.mustache')

class FAQArticleView extends Backbone.View
  @VIEWID = 2

  initialize: (options) ->
    @options = options || {}
    @I18nScope = 'modules.faq'
    @deatiledArticleTemplate = FaqDetailedarticleTemplate
    @summarizedArticleTemplate = FaqSummarizedarticleTemplate
    @breadCrumbView = @options.breadCrumbView
    @summarized = if @options.summarized then true else false
    @container = @options.container
    @contentModel = @options.contentModel
    @truncationLimit = 200
    @errorContainer = @options.errorContainer

  events :
    "click .rating"  : "handleRatingClicked"

  render :(topicId, articleId) ->
    @searchId = "#{topicId}#{articleId}"
    data = @getArticleHash()
    if @checkArticleId(articleId, data)
      @constructArticlePage(data)
    else
      successCallack = (response) =>
        @constructArticlePage(response)
      errorCb = (data) =>
        data ?= {}
        @errorCallback(data)
      @contentModel.fetchContent({topicId:topicId, articleId: articleId, searchId: @searchId, category: "article"}, successCallack, errorCb)

  errorText: () ->
    if Groupon.FAQ.ViewManager.isV2View()
      I18n.t('js.modules.faq.refresh_browser')
    else
      I18n.t('js.modules.faq.not_found')

  checkArticleId  : (articleId, data) ->
    if data?.article?
      return data.article.id is articleId
    else
      return false

  getArticleHash: () ->
    data = @contentModel.attributes
    if data?.article?
      return data
    else
      return null

  constructArticlePage : (response) ->
    if response? && response.article? && response.topic?
      topicHash =
        searchId : response.topic.searchId
        text : response.topic.text?.replace(/(<([^>]+)>)/ig,"")
      @breadCrumbView.addCrumbs(topicHash)

      articleHash =
        searchId : response.article.searchId
        text : response.article.heading?.replace(/(<([^>]+)>)/ig,"")
      @breadCrumbView.addCrumbs(articleHash)
      @toHtml(response)
    else
      @invalidResponseCallback({searchId : @searchId})

  toHtml : (response)->
    if response.article?
      response.article.heading = response.article.heading.replace(/(<([^>]+)>)/ig,"") if response.article.heading?
      @temporaryArticleTemplate = Hogan.compile(response.article.text)
      response.article.text = toHtml(@temporaryArticleTemplate, window.currentUser, @I18nScope)
      if @summarized
        @constructSummarizedArticle(response)
      else
        hash = $.extend(true, {}, response.article, window.currentUser)
        @$el.html toHtml(@deatiledArticleTemplate, hash , @I18nScope)
        @breadCrumbView.render()
        @container.html(@el)

  constructSummarizedArticle : (response) ->
    hash = $.extend(true, {}, response.article, window.currentUser)
    @$el.html toHtml(@summarizedArticleTemplate, hash , @I18nScope)
    @$('.article-text-container').dotdotdot({
      height : 60
    })
    orgContent = @$('.article-text-container').triggerHandler("originalContent")
    orgContent = orgContent?.text()?.trim()
    if orgContent?.length > @truncationLimit
      indexOfSpace = orgContent.indexOf(' ', @truncationLimit)
      if indexOfSpace > -1
        truncatedContent = orgContent.substring(0, indexOfSpace)
      else
        truncatedContent = orgContent
      truncatedContent = "#{truncatedContent}...<a class='read-more' searchId='#{response.article.searchId}' href='##{response.article.searchId}'>#{I18n.t("js.modules.faq.readmore")}</a>"
      @$('.truncated-article-container').html( truncatedContent )
    else
      @$('.article-text-container').show()
    @container.append(@el)

  handleRatingClicked: (event) ->
    $target = $(event.target)
    if $target.is("a")
      propagateEventBeforeReplacingElements(()=>
        $(".ratings",@$el).hide()
        $(".thanks",@$el).show()
      )
    return true

  errorCallback : (data) ->
    Groupon.FAQ.ViewManager.renderErrorHtml({
      container: @errorContainer
      query : data.searchId
      errorHtmlText : "<div data-bhw='faq___#{encodeURIComponent(data.searchId)}___no-results-displayed-for-articles-api-failure' class='noResults'>#{@errorText()}</div>"
    })

  invalidResponseCallback : (data) ->
    Groupon.FAQ.ViewManager.renderErrorHtml({
      container : @errorContainer
      query : data.searchId
      errorHtmlText : "<div data-bhw='faq___#{encodeURIComponent(data.searchId)}___no-results-displayed-for-articles-api-invalid' class='noResults'>#{I18n.t('js.modules.faq.not_found')}</div>"
    })

module.exports = FAQArticleView
